// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2IcXF","radioRow":"SimpleQuestionBuilderModal_radioRow__10YhZ"};